export const SCREENING_FLOW = {
    STI: "sti",
    HPV: "hpv",
} as const;

export type ScreeningFlow = typeof SCREENING_FLOW[keyof typeof SCREENING_FLOW];

export const isScreeningFlow = (value: unknown): value is ScreeningFlow =>
    value === SCREENING_FLOW.STI || value === SCREENING_FLOW.HPV;
